import { Autocomplete as MuiAutocomplete } from '@material-ui/lab';
import styled from 'styled-components';
import { ColSpan } from '../types';
import { generateColSpan } from '../utils';

interface AutocompleteProps {
  colspan?: ColSpan;
}

export const Autocomplete: typeof MuiAutocomplete = styled(MuiAutocomplete)<AutocompleteProps>`
  ${({ colspan }) => (colspan ? generateColSpan(colspan) : '')}
`;
